import { DEFAULT_FILTER } from '../constants/filter';

export const checkIsFilterApplied = (filter) => {
	return JSON.stringify(filter) !== JSON.stringify(DEFAULT_FILTER);
};
